class RouteSuggestionModel extends App.Models.BaseModel {
    modelUrl = '';
}

App.Models.RouteSuggestion = RouteSuggestionModel;
